module.exports = __webpack_public_path__ + "media/images/upload-cover-85042c30c95e99b096d15eb19234ffbb.jpg";